import type { LayoutLoad } from './$types';
import { PUBLIC_IS_ECOMMERCE_PROJECT } from '$env/static/public';
import api from '$lib/api/ecom/shopify'

/**
 * Entry function on first page load, detects language and loads global data.
 */
export const load: LayoutLoad = async ({ parent }) => {
	const data = await parent()

	// Init api
	if (PUBLIC_IS_ECOMMERCE_PROJECT) {
		api.init(data.pageConfig.shopify_api_key, data.pageConfig.shopify_endpoint)
	}

	return {};
};